<!-- =========================================================================================
  File Name: TheNavbar.vue
  Description: Navbar component
  Component Name: TheNavbar
  ----------------------------------------------------------------------------------------
========================================================================================== -->


<template>
  <div class="relative bg-white">

    <div class="vx-navbar-wrapper" :class="classObj">

      <vs-navbar class="vx-navbar navbar-custom navbar-skelton" :color="navbarColorLocal" :class="textColor">
        <!-- SM - OPEN SIDEBAR BUTTON -->
        <feather-icon class="sm:inline-flex xl:hidden cursor-pointer p-2" icon="MenuIcon" @click.stop="showSidebar" />
        <!-- <bookmarks :navbarColor="navbarColor" v-if="windowWidth >= 992" /> -->
        <vs-alert v-if="this.me.tenant.status !== 'active' " color="primary" :style="{width: 'auto'}">
          {{ tenantStatus }}
        </vs-alert>
        <vs-alert class="w-auto" color="danger" v-if="trialAlert">{{ trialAlert }} <span class="text-link text-primary cursor-pointer" @click="openSignUpTrialAlert">Sign up now</span></vs-alert>
        <vs-spacer />

        <!--<notification-drop-down />-->

        <profile-drop-down />

      </vs-navbar>
    </div>
  </div>
</template>


<script>
import Bookmarks            from './components/Bookmarks.vue'
import SearchBar            from './components/SearchBar.vue'
import NotificationDropDown from './components/NotificationDropDown.vue'
import ProfileDropDown      from './components/ProfileDropDown.vue'

import { mapGetters, mapState } from 'vuex'

export default {
  name: 'the-navbar-vertical',
  props: {
    navbarColor: {
      type: String,
      default: '#fff'
    }
  },
  components: {
    // Bookmarks,
    // SearchBar,
    // NotificationDropDown,
    ProfileDropDown
  },
  computed: {
    ...mapState('auth', ['me']),
    navbarColorLocal () {
      return this.$store.state.theme === 'dark' && this.navbarColor === '#fff' ? '#10163a' : this.navbarColor
    },
    verticalNavMenuWidth () {
      return this.$store.state.verticalNavMenuWidth
    },
    textColor () {
      return {'text-white': (this.navbarColor !== '#10163a' && this.$store.state.theme === 'dark') || (this.navbarColor !== '#fff' && this.$store.state.theme !== 'dark')}
    },
    windowWidth () {
      return this.$store.state.windowWidth
    },

    // NAVBAR STYLE
    classObj () {
      if (this.verticalNavMenuWidth === 'default')      return 'navbar-default'
      else if (this.verticalNavMenuWidth === 'reduced') return 'navbar-reduced'
      else if (this.verticalNavMenuWidth)              return 'navbar-full'
      return ''
    },
    ...mapGetters('auth', ['trialAlert', 'accountActive']),
    tenantStatus() {
      let {status} = (this.me || {}).tenant || {};
      status = status || "";
      return status.charAt(0).toUpperCase() + status.slice(1);
    }
  },
  methods: {
    showSidebar () {
      this.$store.commit('TOGGLE_IS_VERTICAL_NAV_MENU_ACTIVE', true);
    },
    openSignUpTrialAlert () {
      this.$root.$tcPopup.show({
        classes: `${this.accountActive ? '' : 'vs-dialog--prevent-closing'}`,
        data: {
          message: this.trialAlert
        },
        title: `Sign Up`,
        component: 'TrialAlert',
        buttonsHidden: true
      })
    }
  },
}
</script>

